/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */
import * as React from "react";
import { Tooltip, IconButton, Menu, MenuItem } from "@mui/material";
import { menuSlotProps, moreIconButtonSxProps } from "../../helpers";
import { setSelectedLanDevice, setIsAddNewLanDevice, setIsAddNewIPInterface } from "../../../store/api/deviceConfig/reducers";
import { ILanDevice } from "../../../store/api/deviceConfig/types";
import { useStoreDispatch } from "../../../store/hooks";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { setBasicDialogOpenFor, setOpenCustomDailog } from "../../../store/helpers/helperReducers";
import { useLanDeviceData } from "./hooks";
import { DIALOGOPENFOR } from "../../../globals/globals";
import { useSelector } from "react-redux";
import { selectedDeviceSelector } from "../../../store/api/devices/selectors";


interface ILANDeviceActionMenuProps {
  tableRow: any;
}

const LANDeviceActionMenu: React.FC<ILANDeviceActionMenuProps> = ({ tableRow }) => {
  const dispatch = useStoreDispatch();

  const { permissions, deleteLanDeviceHandler, anchorElLanDevice, setAnchorElLanDevice } = useLanDeviceData();
  const openMenuLanDevice = Boolean(anchorElLanDevice);
  const selectedDevice = useSelector(selectedDeviceSelector);
  const isOfflineDevice = selectedDevice?.configurationStatus?.toLowerCase() === "offline";
  const handleOnMoreIconLanDeviceClick = (event: React.MouseEvent<HTMLButtonElement>, selectedRow: ILanDevice) => {
    setAnchorElLanDevice(event.currentTarget);
    //const selectedProfileDetails = data.filter((item: IProfile) => item.profileID?.id === index)[0];
    dispatch(setSelectedLanDevice(selectedRow));
    dispatch(setIsAddNewLanDevice(false));
  };

  const addIPInterfaceHandler = () => {
    // dispatch(setSelectedIPInterface(undefined));
    dispatch(setBasicDialogOpenFor(DIALOGOPENFOR.IPINTERFACE));
    dispatch(setIsAddNewIPInterface(true));
  };

  const editLanDeviceHandler = () => {
    dispatch(setOpenCustomDailog(true));
  };

  const handlePopup = (type: string) => {
    setAnchorElLanDevice(null);
    if (type === "Edit") {
      return editLanDeviceHandler();
    } else if (type === "Delete") {
      return deleteLanDeviceHandler();
    } else {
      return addIPInterfaceHandler();
    }
  };

  const isEnableMoreIcon = !!tableRow?.status && (tableRow?.status.toLowerCase() === "inprogress" || tableRow?.status.toLowerCase() === "failed");
  return (
    permissions?.hasOpCodeGroup("manage_topology") && !isOfflineDevice && (
      <>
        <Tooltip title="Lan Device Settings" arrow>
          <IconButton
            sx={moreIconButtonSxProps}
            aria-label="more"
            id="lan-device-setting"
            aria-controls={openMenuLanDevice ? "lan-device-menu" : undefined}
            aria-expanded={openMenuLanDevice ? "true" : undefined}
            aria-haspopup="true"
            onClick={(event) => handleOnMoreIconLanDeviceClick(event, tableRow)}
            disabled={isEnableMoreIcon}>
            <MoreVertIcon />
          </IconButton>
        </Tooltip>
        <Menu
          id="lan-device-menu"
          anchorEl={anchorElLanDevice}
          open={openMenuLanDevice}
          onClose={() => setAnchorElLanDevice(null)}
          MenuListProps={{
            "aria-labelledby": "lan-device-setting",
          }}
          slotProps={menuSlotProps}
          transformOrigin={{ horizontal: "right", vertical: "top" }}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}>
          <MenuItem onClick={() => handlePopup("Add")}>Add IP Interface</MenuItem>
          <MenuItem onClick={() => handlePopup("Edit")}>Edit Lan Device</MenuItem>
          <MenuItem onClick={() => handlePopup("Delete")}>Delete Lan Device</MenuItem>
        </Menu>
      </>
    )
  );
};

export default LANDeviceActionMenu;
